import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../views/types';

type BuildAnswersPropsType<T> = {
  keyName: string;
  answers: Merge<T & BaseAnswerType>[];
  answerHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  gaEventName: string;
};
export const buildAnswers = <T, >({
  keyName,
  answers,
  answerHandler,
  gaEventName,
}: BuildAnswersPropsType<T>): Required<Merge<T & BaseAnswerType>>[] => {
  return answers.map((answer, index) => {
    const { id, value, textContents, ...options } = answer;

    return {
      keyName,
      id: id ?? index + 1,
      value,
      textContents: textContents || answer.value,
      gaEventName,
      answerHandler,
      ...options,
    } as Required<Merge<T & BaseAnswerType>>;
  });
};

const unsupportedWords = [
  'はい', 'いいえ', 'わかりません', 'おまかせします', '決まっていません', 'ざっくり決まっています', '具体的に決まっています', '10年以内です', '20年以内です', '20年以上です',
  '写真のように白くなります', '少し白くなります', 'あります', 'より大きなヒビがあります', '1cm以上が複数あります', '1cmくらいが3カ所以下あります',
  '所々みられます', '所々あります', 'ヘリや端に少しあります', '複数あります', '雨の日に水滴が落ちます', '天井にシミがあります', '屋根面に所々あります', '全体的にみられます', '少しあります', 'ありません',
];
export const buildUserAnswerMessage = (answer: string) => {
  const answerText = unsupportedWords.includes(answer) ? answer : `${answer}です`;

  return (
    <>
      {answerText}
    </>
  );
};
